export default "__VITE_ASSET__o8irM3Yd__"